import React from "react";

const TemarioPosgradoInvestigacionClinica = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Fundamentos éticos e introducción a la investigación clínica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Historia y fundamentos éticos: Código de Núremberg y Declaración de Helsinki"}</span></li>
                <li><span className="fw-light">{"Mitos de la investigación clínica farmacológica"}</span></li>
                <li><span className="fw-light">{"Fases y secuencia de la investigación: del diseño del protocolo al archivo"}</span></li>
                <li><span className="fw-light">{"Dimensión financiera de la investigación de farmacología clínica"}</span></li>
            </ul>
            <br /><br />

            <b>{"Buenas Prácticas Clínicas, bioestadística y diseño de estudios"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"ICH E6(R3), Buenas Prácticas Clínicas, Quality by Design y enfoque basado en riesgo"}</span></li>
                <li><span className="fw-light">{"Bioestadística aplicada: hipótesis, tamaño muestral, poder estadístico, aleatorización y plan estadístico (SAP)"}</span></li>
                <li><span className="fw-light">{"Diseños clásicos: paralelo, cruzado, factorial, no inferioridad y equivalencia"}</span></li>
                <li><span className="fw-light">{"Diseños innovadores: adaptativos, de plataforma, aleatorización dinámica, basket/umbrella"}</span></li>
                <li><span className="fw-light">{"Plataformas de ensayos adaptativos impulsadas por métodos bayesianos"}</span></li>
            </ul>
            <br /><br />

            <b>{"Protocolo, inteligencia artificial y nuevas tecnologías"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Redacción de protocolos según ICH E6(R3): objetivos, criterios y justificación científica"}</span></li>
                <li><span className="fw-light">{"Ecosistema de IA en reclutamiento, protocolos, operaciones y adherencia: calidad y sesgo"}</span></li>
                <li><span className="fw-light">{"Gemelos digitales, datos sintéticos y brazos de control sintéticos: validez y límites"}</span></li>
            </ul>
            <br /><br />

            <b>{"Marco regulatorio, ética y protección de datos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Marco regulatorio argentino: ANMAT, Disposición 7516/2025, Ley 27.447 y RENIS"}</span></li>
                <li><span className="fw-light">{"Consentimiento informado, poblaciones vulnerables, diversidad e inclusión"}</span></li>
                <li><span className="fw-light">{"Comités de ética, conflictos de interés, integridad científica y protección de datos personales"}</span></li>
                <li><span className="fw-light">{"Revisión de casos clínicos y bioética: decisiones de inclusión/exclusión y discusión de casos reales"}</span></li>
            </ul>
            <br /><br />

            <b>{"Activación del centro, gobernanza de IA y datos del mundo real"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Factibilidad y activación del sitio; presupuestos y contratos con patrocinadores y CROs"}</span></li>
                <li><span className="fw-light">{"Gobernanza y regulación de IA en salud: Unión Europea, FDA y EMA"}</span></li>
                <li><span className="fw-light">{"Real World Data y Real World Evidence: fuentes, calidad y uso regulatorio complementario"}</span></li>
                <li><span className="fw-light">{"Relación con CROs y patrocinadores: contratos, cronogramas, technical agreement y seguros"}</span></li>
            </ul>
            <br /><br />

            <b>{"Investigación descentralizada y equipo de investigación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Rol de ANMAT como autoridad reguladora de referencia regional y cooperación internacional"}</span></li>
                <li><span className="fw-light">{"Ensayos clínicos descentralizados, telemedicina, enfermería domiciliaria y wearables"}</span></li>
                <li><span className="fw-light">{"Rol del investigador principal, del equipo y del monitor (CRA); responsabilidades legales y Log of Delegation"}</span></li>
                <li><span className="fw-light">{"Coordinador de Investigación Clínica: competencias y articulación entre los actores del estudio"}</span></li>
            </ul>
            <br /><br />

            <b>{"Logística, monitoreo y documentación del ensayo"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Logística y trazabilidad del producto en investigación (IMP): distribución, almacenamiento y cadena de custodia"}</span></li>
                <li><span className="fw-light">{"Monitoreo presencial, híbrido y remoto: sistemas y áreas clave de conocimiento del CRA"}</span></li>
                <li><span className="fw-light">{"Trial Master File: componentes, versionado y documentos esenciales"}</span></li>
                <li><span className="fw-light">{"Financiamiento internacional para investigación (Grants): oferta y aplicación"}</span></li>
            </ul>
            <br /><br />

            <b>{"Seguridad, inspecciones y auditorías"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Seguridad en ensayos clínicos: señales, pre-señales, tipos de reporte y tiempos regulatorios"}</span></li>
                <li><span className="fw-light">{"Inspecciones de Buenas Prácticas Clínicas de ANMAT"}</span></li>
                <li><span className="fw-light">{"Preparación para auditorías e inspecciones; gestión de hallazgos, CAPA y Visita de Cierre del Centro (COV)"}</span></li>
            </ul>
            <br /><br />

            <b>{"Historia clínica, comunicación y divulgación científica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Historia clínica electrónica en investigación: interoperabilidad y estándares (SNOMED-CT, MedDRA, HL7)"}</span></li>
                <li><span className="fw-light">{"Comunicación: diseño de estrategia, redes sociales y publicidad no tradicional (PNT/MNT)"}</span></li>
                <li><span className="fw-light">{"Comunicación con medios, pacientes y comunidad científica; periodismo científico y divulgación responsable"}</span></li>
            </ul>
            <br /><br />

            <b>{"Oportunidades profesionales, innovación y cierre"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Oportunidades de la investigación clínica en Argentina: red de centros, salidas laborales y certificación"}</span></li>
                <li><span className="fw-light">{"Identificación de áreas, redes, convocatorias y financiamiento para proyectos de investigación"}</span></li>
                <li><span className="fw-light">{"Estudios de vanguardia: casos de investigación de farmacología clínica innovadora"}</span></li>
                <li><span className="fw-light">{"Propiedad intelectual, ley de patentes y protección de datos de prueba"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioPosgradoInvestigacionClinica;
